import React from 'react'
import { Img, ImgProps } from 'react-image'

export const DEFAULT_AVATAR_FALLBACK =
  'https://s6.uupload.ir/files/profile-pic_m5r7.png'

type Props = ImgProps & {
  fallback?: string
}

const randomString = new Date().getTime()

const addRandomQueryParamToDisableCache = (src: string) => {
  if (src.includes('blob')) return src
  return `${src}?amir=${randomString}`
}

const Image = (props: Props) => {
  const { src } = props
  let imageSrc: string[] = []

  if (Array.isArray(src)) {
    imageSrc = [
      ...src.map(addRandomQueryParamToDisableCache),
      DEFAULT_AVATAR_FALLBACK,
    ]
  } else if (typeof src === 'string') {
    imageSrc = [addRandomQueryParamToDisableCache(src), DEFAULT_AVATAR_FALLBACK]
  } else {
    imageSrc = [DEFAULT_AVATAR_FALLBACK]
  }

  return <Img {...props} src={imageSrc} key={JSON.stringify(imageSrc)} />
}

export default Image
